export const setPosition = (satPos, i, pos) => {
    satPos[i * 3] = pos.x;
    satPos[i * 3 + 1] = pos.y;
    satPos[i * 3 + 2] = pos.z;
    return satPos;
};
export const resetPosition = (satPos, i) => {
    satPos[i * 3] = 0;
    satPos[i * 3 + 1] = 0;
    satPos[i * 3 + 2] = 0;
    return satPos;
};
export const resetVelocity = (satVel, i) => {
    satVel[i * 3] = 0;
    satVel[i * 3 + 1] = 0;
    satVel[i * 3 + 2] = 0;
    return satVel;
};
